import alt from "../alt";

class UserActions {
  constructor() {
    this.generateActions(
      "updateApiKey",
      "updateDetails",
      "loginSucceeded",
      "loginWithToken",
      "loginFailed",
      "clearErrors",
      "logout",
      "fetch",
      "forgotPassword",
      "forgotSucceeded",
      "forgotFailed",
      "resetSucceeded",
      "resetFailed",
      "fetchUser",
      "edit",
      "editUser",
      "setData",
      "fetchFailed",
      "editFailed",
      "fetchRoles",
      "fetchAccounts",
      "deleteAccount",
      "createAccount",
      "fetchAllUsers",
      "fetchPaginatedUsers",
      "fetchCurrentPage",
      "fetchCondensedUsers",
      "setGodUser",
      "setGodRole",
      "godAutoCreateUser",
      "godCreateUser",
      "godDeleteUser",
      "godSetStealthMode",

      "userSignup",
      "lookupContentCreatorInvite",
      "acceptContentCreatorInvite",
      "lookupRevenueSharingInvite",
      "acceptRevenueSharingInvite"
    );
  }

  login(email, password, noRedirect) {
    return { email, password, noRedirect };
  }

  register(email, password) {
    return { email, password };
  }

  editAccount(id, values) {
    return { id, values };
  }

  uploadFile(key, file) {
    return { key, file };
  }

  godEditUser(id, values) {
    return { id, values };
  }

  resetPassword(token, password) {
    return { token, password };
  }
}

export default alt.createActions(UserActions);



// WEBPACK FOOTER //
// ./src/app/actions/UserActions.js